import { Box, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import theme from '../../theme/theme';
const FaceScanInstruction = ({videoContainerSx}) => {
  const videoRef = useRef(null);
    const isSmallHeight = useMediaQuery('(max-height:700px)');
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.7; // Slow down by 2.5x (1 / 2.5 = 0.4)
      videoRef.current.play(); // Start the video immediately
    }
  }, []);

  return (
    <Stack spacing={ isSmallHeight ? 1 : 2 } sx={ { width: '100%' } }>
      <Typography sx={{
        color: "#30373E",
        textAlign: "center",
        fontFamily: "Poppins",
        fontSize: isSmallHeight ? "18px" : "20px",
        fontWeight: "700",
        lineHeight: "27px",
        // marginTop : "20px",
        lineHeight: isSmallHeight ? "24px" : "27px",
      }}>
        Make sure your brightness is turned all the way up.
      </Typography>
      <Typography
        sx={{
          color: "#000",
          textAlign: "center",
          fontSize: "15px",
          fontWeight: "400",
          lineHeight: "20px",
          // mx: "auto",
        }}>
        This will ensure the scan is able to work properly.
      </Typography >
      <Box sx={ {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        ...videoContainerSx
      } }>
        <video
          ref={ videoRef }
          height={ isSmallHeight ? "130px" : isSmallScreen ? "150px" : "180px" }
          width="auto"
          style={ {
            maxWidth: "100%",
            maxHeight: isSmallHeight ? "130px" : isSmallScreen ? "150px" : "180px"
          } }
          autoPlay
          muted
          loop
          controls={false}  // Disables video controls (play, pause, etc.)
          playsInline  // Ensures the video plays inline on mobile (iOS devices)
          >
          <source src="/videos/increase_brighntess-instruction.mov" type="video/mp4" />
        </video>
      </Box>
    </Stack >
  )
}

FaceScanInstruction.propTypes = {
  videoContainerSx: PropTypes.object,       // The sx styles for the video container (optional)
};

export default FaceScanInstruction